import { Player } from './player';

export abstract class RemotePlayer extends Player {

    public override requiresDeferredStationChange (): boolean {
        return true;
    }

    public override requiresDeferredVolumeChange(): boolean {
        return true;
    }

    public override getSchedulerInterval (): number {
        return 20000;
    }

    public override canBeStopped (): boolean {
        return false;
    }

}
